import {
  ExecutionDateParametersFields,
  ExecutionTargetParametersType,
  ScheduleRecurrenceData
} from "@emisgroup/cohort-builder-kit";
import { ReccurrenceEditItem } from "../../EditReccurrenceForm/Types";
import { OutputConfigPickerItem } from "../../OutputConfigPicker/Types";

export enum SchedulingModes {
  VIEW = "view",
  CREATE = "Create",
  EDIT = "Edit"
}
export interface IRecurranceDataType {
  month?: number;
  day?: number;
  selectedWeekDays?: number[];
  calculation?: string[];
}

export interface OutputConfigType {
  /**
   * Output config id
   */
  id: string;
  /**
   * Output config name
   */
  name: string;
  /**
   * Output config survey name
   */
  surveyName: string;
}
export interface IScheduleInstanceType {
  /**
   * Instance Id
   */
  id: string;
  /**
   * Instance run date
   */
  runDate: string;
  /**
   * Target parameters
   */
  executionTargetParameters: ExecutionTargetParametersType;
  /**
   * Date Parameter
   */
  executionDateParameters: ExecutionDateParametersFields;
  /**
   * Execution Control
   */
  executionControls: ExecutionControlsTypes;
  /**
   * Output config
   */
  outputConfigs: OutputConfigType[];
  /**
   * Created by
   */
  createdBy: string;
  /**
   * Created on
   */
  createdOn: string;
  /**
   * Modified by
   */
  modifiedBy: string;
  /**
   * Modified on
   */
  modifiedOn: string;
  /**
   *Activate schedule 
   */
  isActive: boolean;
}

export interface ExecutionControlsTypes {
  /**
   * Batches count
   */
  batches: number;
  /**
   * Error mode
   */
  errorMode: string;
  /**
   * Run Batches count
   */
  parallelRun: {
    /**
     * Maximum batches count
     */
    maxRunBatches: number;
    /**
     * Maximum batch nodes
     */
    maxRunBatchNodes: number;
    /**
     * Maximum run request
     */
    maxRunRequestNodes: number;
  };
}

export interface IScheduleListType {
  /**
   * Artefact id
   */
  artefactGuid: string;
  /**
   * Schedule id
   */
  id: string;
  /**
   * Schedule name
   */
  scheduleName: string;
  /**
   * Recurrence Type
   */
  recurrenceType: string;
  /**
   * Recurrence Data
   */
  recurrenceData: ScheduleRecurrenceData;
  /**
   * Target parameters
   */
  executionTargetParameters: ExecutionTargetParametersType;
  /**
   * Execution controls
   */
  executionControls: ExecutionControlsTypes;
  /**
   * Schedule active
   */
  isActive: boolean;
  /**
   * Schedule instance
   */
  scheduleInstances: any[];
  /**
   * Schedule validity
   */
  isValid: boolean;
}

export interface ISchedueListResponse {
  /**
   * Schedule list
   */
  scheduleList: IScheduleListType[] | [];
}

export interface ISchedueListTable {
  scheduleName: { text: string | JSX.Element };
  activeInLive: { text: string | JSX.Element };
  recurrenceType: { text: string };
  recurrenceRangeStart: { text: string | JSX.Element };
  recurrenceRangeEnd: { text: string | JSX.Element };
}

export interface IInitialState {
  isScheduleListPage: boolean;
  mode: SchedulingModes;
  isEndBy: boolean;
  isEndAfter: boolean;
  schedulingDetails: ScheduleDetails;
  scheduleList: ISchedueListResponse;
  scheduleInstances: IScheduleInstanceType[];
  isValidScheduleName?: boolean;
  /**
   * Flag to show schedule popup
   */
  isShowSchedulePopup?: boolean;
  /**
   * Scheduling Recurrence Item
   */
  schedulingRecurrenceItem: ReccurrenceEditItem;
  /**
   * Flag to enable scheduling popup save
   */
  enableSchedulingPopupSave: boolean;
  /**
   * Picker output config list
   */
  pickerConfigList: OutputConfigPickerItem[];
  /**
   * Selected scheduling id
   */
  schedulingId: number;
}

export interface ISchedueInstanceTable {
  scheduleInstanceId: { text: string };
  runDate: { text: string | JSX.Element };
  relativeRunDate: { text: string | JSX.Element };
}

export interface IFieldDetails {
  value: string | Date | number | Array<number>;
  valid: boolean;
  errorText: string;
}

export interface ScheduleDetails {
  extractGuid?: string;
  scheduleGuid?: string;
  scheduleName: string;
  activeInLive?: boolean;
  recurrenceType: string;
  recurrenceRunTime: string;
  recurrenceData?: IScheduleRecurrenceData;
  recurrenceRangeStart: string;
  recurrenceRangeEnd?: string;
  recurrenceNoOfOccurrences?: string;
}

export interface IScheduleRecurrenceData {
  month?: number;
  day?: number;
  selectedWeekDays?: Array<number>;
  calculation?: Array<string | number>;
}

export interface ISaveScheduleRequest {
  data: {
    type: string;
    attributes: ScheduleDetails;
  };
}
